module.exports = __webpack_public_path__ + "static/media/ClassesBackgroundImage.4cb577c1.jpg";